import React, { createContext, useContext, useState, useCallback } from "react";
import CalculatorModal from "../components/Global/calculator-modal";

const CalculatorModalContext = createContext(null);

export function CalculatorModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [calculatorName, setCalculatorName] = useState("EMI Calculator");

  const openCalculatorModal = useCallback((name = "EMI Calculator") => {
    setCalculatorName(name);
    setIsOpen(true);
  }, []);

  const closeCalculatorModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <CalculatorModalContext.Provider
      value={{
        isOpen,
        calculatorName,
        openCalculatorModal,
        closeCalculatorModal,
      }}
    >
      {children}

      {/* Global Calculator Modal Popup */}
      <CalculatorModal
        isOpen={isOpen}
        onClose={closeCalculatorModal}
        calculatorName={calculatorName}
      />
    </CalculatorModalContext.Provider>
  );
}

export function useCalculatorModal() {
  const context = useContext(CalculatorModalContext);
  if (!context) {
    throw new Error("useCalculatorModal must be used within a CalculatorModalProvider");
  }
  return context;
}
